/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createExp } from '../../factoriesNumber.js';
export var expDependencies = {
  typedDependencies,
  createExp
};